module.exports = __webpack_public_path__ + "img/armellini_no_config.2605f2aa.svg";